'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _jqueryParam = require('jquery-param');

var _jqueryParam2 = _interopRequireDefault(_jqueryParam);

var _default = require('../config/default');

var _default2 = _interopRequireDefault(_default);

var _overrides = require('../config/overrides');

var _overrides2 = _interopRequireDefault(_overrides);

var _configBuilder = require('./configBuilder');

var _configBuilder2 = _interopRequireDefault(_configBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var keysPresent = function keysPresent(hash) {
  return Object.keys(hash).length > 0;
};

var BaseClient = function () {
  function BaseClient(authToken, headers) {
    _classCallCheck(this, BaseClient);

    this.configBuilder = new _configBuilder2.default(this, _default2.default);
    this.authToken = authToken;
    this.headers = headers;
  }

  _createClass(BaseClient, [{
    key: 'type',
    value: function type(_type) {
      this.resourceType = _type;
      return this;
    }
  }, {
    key: 'get',
    value: function get(requestType) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.configBuilder._setBasicConfigOverrides(requestType);

      if (keysPresent(options)) {
        if (options.filter) this.configBuilder._setFilter(options.filter);
        if (options.single) this.configBuilder._setSinglePath(options.single);
        if (options.search) this.configBuilder._setSearchFilter(options.search);
        if (options.params) this.configBuilder._setParams(options.params);
      };

      return this._execute();
    }
  }, {
    key: 'put',
    value: function put(requestType) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.configBuilder._setBasicConfigOverrides(requestType);

      if (options.file_upload) {
        this.configBuilder._setFileUploadConfigs(options);
      } else {
        this.configBuilder._setUpdateConfigOverrides('PUT', options);
      }

      return this._execute();
    }
  }, {
    key: 'patch',
    value: function patch(requestType) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.configBuilder._setBasicConfigOverrides(requestType);
      this.configBuilder._setUpdateConfigOverrides('PATCH', options);

      return this._execute();
    }
  }, {
    key: 'post',
    value: function post(requestType) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.configBuilder._setBasicConfigOverrides(requestType);
      this.configBuilder._setUpdateConfigOverrides('POST', options);

      if (keysPresent(options)) {
        if (options.meta) this.configBuilder._setMeta(options.meta);
      };

      return this._execute();
    }
  }, {
    key: 'delete',
    value: function _delete(requestType) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.configBuilder._setBasicConfigOverrides(requestType);
      this.configBuilder._setUpdateConfigOverrides('DELETE', options);

      return this._execute();
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile(requestType) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.configBuilder._setBasicConfigOverrides(requestType);
      this.configBuilder._setDeleteFileUploadConfigs(options);

      return this._execute();
    }
  }, {
    key: '_buildRequestConfig',
    value: function _buildRequestConfig() {
      var _configBuilder$baseCo = this.configBuilder.baseConfig,
          method = _configBuilder$baseCo.method,
          path = _configBuilder$baseCo.path,
          data = _configBuilder$baseCo.data,
          baseURL = _configBuilder$baseCo.baseURL,
          content_type = _configBuilder$baseCo.content_type,
          accept_header = _configBuilder$baseCo.accept_header;


      var config = Object.assign({}, this.configBuilder.baseConfig, {
        baseURL: baseURL + '/api',
        url: path,
        paramsSerializer: function paramsSerializer(params) {
          return (0, _jqueryParam2.default)(params);
        },
        headers: _extends({
          'Accept': accept_header,
          'Content-Type': content_type,
          'Authorization': this.authToken
        }, this.headers)
      });

      return config;
    }
  }, {
    key: '_execute',
    value: function _execute() {
      var config = this._buildRequestConfig();

      if (process.env.NODE_ENV !== 'production') console.log("SUPA DUPA NEW API REQUEST CONFIG!!!:", config);

      return _axios2.default.request(config);
    }
  }]);

  return BaseClient;
}();

exports.default = BaseClient;